class PostsLoop {
    constructor(postsBlock) {
        this.loadMoreCard = postsBlock.querySelector('.o-js-load-more')
        this.button = postsBlock.querySelector('.o-js-load-more .wp-element-button')

        if (this.button) {
            this.nonce = this.button.dataset.nonce
            this.archiveType = this.button.dataset.archive
            this.action = 'sprocess_load_more_posts'
            this.page = 0

            this.button.addEventListener('click', function (e) {
                e.preventDefault()

                let _data = {
                    action: this.action,
                    nonce: this.nonce,
                    archive: this.archiveType,
                    page: this.page,
                }

                fetch(window.ajaxData.ajaxUrl, {
                    method: 'POST',
                    body: (new URLSearchParams(_data)).toString(),
                    headers: { 'Content-type': 'application/x-www-form-urlencoded' }
                })
                    .then(response => response.text())
                    .then(function (data) {
                        const result = JSON.parse(JSON.parse(data))

                        this.loadMoreCard.parentNode.insertBefore(this.elementFormString(result.html), this.loadMoreCard)
                        this.page = this.page + 1

                        if (result.count <= 8) {
                            this.loadMoreCard.remove()
                        }

                    }.bind(this));
            }.bind(this))
        }
    }

    elementFormString(htmlString) {
        let container = document.createElement('div')
        let frag = document.createDocumentFragment();

        container.innerHTML = htmlString;

        while (container.firstChild) {
            frag.appendChild(container.removeChild(container.firstChild));
        }

        return frag;
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    const postsBlocks = document.querySelectorAll('.c-blog-posts')

    if (postsBlocks.length) {
        postsBlocks.forEach(postsBlock => {
            new PostsLoop(postsBlock)
        });
    }
});
